export default {
      id: "common__delete-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__delete",
      toString: function () {
        return this.url;
      }
    }